@if (isReadOnly()) {
  <div class="w-full h-full">
    <div class="flex flex-col gap-3">
      <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">{{ isFlightOnly() ? 'CLC Staff Member' : 'CLC Staff Members' }}</div>

      <div class="grid [grid-template-columns:max-content_auto_auto_auto] lg:w-2/3 w-full items-center border border-surface-400 rounded-lg"
           [style.grid-template-columns]="isFlightOnly() ? 'max-content auto' : null">
<!--          Header-->
        <div class="h-full">
        </div>
        <div class="flex flex-col px-4 py-3 gap-3">
          <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Traveller</div>
        </div>
        @if (!isFlightOnly()) {
          <div class="flex flex-col px-4 py-3 gap-3">
            <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Traveller Will Acquit</div>
          </div>
          <div class="flex flex-col px-4 py-3 gap-3">
            <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Pre-payment Requested</div>
          </div>
        }
<!--          Readonly Travellers-->
        @for (traveller of sortedTravellers(); track traveller;) {
          <div class="col-span-full h-[1px] bg-surface-200"></div>
          <div class="px-4 py-3">
            @if (!!traveller.details?.id && traveller?.details?.id === taSubmission()?.primaryTraveller?.details?.id
                 && traveller.details?.userType !== UserType.Casual) {
                <i class="fa fa-star text-yellow-500"></i>
            }
          </div>
          <div class="px-4 py-3">
            <span class="text-xs font-bold font-['Roboto_Condensed'] text-primary-900">{{ traveller.details?.name }}</span>
          </div>
          @if (!isFlightOnly()) {
            <div class="px-4 py-3 flex items-center">
              <p-checkbox
                [ngModel]="traveller.isSelfAcquit"
                [binary]="true"
                disabled
              />
            </div>
            <div class="px-4 py-3 flex items-center gap-2">
              <p-checkbox
                [ngModel]="!!traveller.authorisedAdjustmentDate"
                [binary]="true"
                disabled
              />
              @if (!!traveller.authorisedAdjustmentDate){
                <div class="pl-3 pr-1 py-1 bg-primary-100 rounded-2xl inline-flex justify-start items-center gap-2">
                  <div class="justify-start text-chip-color text-xs font-normal font-['Roboto_Condensed']">{{authorityChipLabel(traveller)}} {{traveller.authorisedAdjustmentDate | date:'dd/MM/yy'}}</div>
                  <div class="rounded-full w-5 h-5 flex items-center justify-center text-white bg-primary text-lg font-medium">
                    <i class="fa-solid fa-check fa-2xs"></i>
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>

      <!-- A flight-only TA has no non-CLC travellers. -->
      @if (!isFlightOnly()) {
        <div class="w-full h-[1px] bg-surface-200 mt-4"></div>
        <div class="w-full py-3">
          <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">Non-CLC Staff</div>
        </div>

        <div class="w-full flex gap-x-30 gap-y-4 flex-wrap">
          @for (nonStaffTraveller of readonlyNonStaffTravellers(); let ii = $index; track nonStaffTraveller) {
            @if (!!nonStaffTraveller) {
              <div class="flex gap-10 px-4 pb-3">
                <div class="text-datatable-row-color text-xs font-semibold font-['Inter']">{{'Traveller ' + (ii + 1)}}</div>
                <div class="text-datatable-row-color text-xs font-normal font-['Inter']">{{nonStaffTraveller}}</div>
              </div>
            }
          } @empty {
            <div class="text-xs font-normal font-['Inter'] leading-[9.75px] px-2 pb-2">
              <i>No non CLC travellers.</i>
            </div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div class="w-full h-full flex flex-col gap-6">
    <p-card>
      <div class="flex gap-2">
        <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          @if (isFlightOnly()) {
            <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">CLC Staff Member<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Add the CLC staff member travelling on this TA.</div>
            @if (isDelegateTa()) {
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">You are raising this TA as the <b>Booking Officer</b>, so you cannot be added as a traveller.</div>
            }
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']"><i>NOTE: Only single travellers can create a flights-only TA.</i></div>
          } @else {
            <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">CLC Staff Members<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">List all CLC staff travelling on this TA.</div>
            @if (isDelegateTa()) {
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">You are raising this TA as the <b>Booking Officer</b>, so you cannot be added as a traveller.</div>
            } @else {
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Remove yourself if you are <i>not</i> travelling.</div>
            }
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">For each traveller select their Acquittal and Pre-payment options.</div>
            @if (isDelegateTa()) {
              <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">As Booking Officer you will acquit every traveller's portion. Tick <i>Traveller Will Acquit</i> if a traveller will acquit their own travel instead.</div>
            }
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']"><i>NOTE: Pre-payment is NOT available for group travel (i.e. more than 1 traveller) or day trips.</i></div>
          }
        </div>

        <div class="flex-1 flex flex-col bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="grid [grid-template-columns:max-content_1fr_1fr_1fr_1fr] w-full bg-surface-0"
               [style.grid-template-columns]="isFlightOnly() ? 'max-content 1fr' : null">
    <!--        Header-->
            <div class="">
            </div>
            <div class="flex flex-col px-4 py-2.5 gap-3">
              <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Person Travelling</div>
            </div>
            @if (!isFlightOnly()) {
              <div class="flex flex-col px-4 py-2.5 gap-3">
                <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Traveller Will Acquit</div>
              </div>
              <div class="flex flex-col px-4 py-2.5 gap-3">
                <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Pre-payment Requested</div>
              </div>
              <div class="flex flex-col px-4 py-2.5 gap-3">
                <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Add/Remove Travellers</div>
              </div>
            }

            <div class="col-span-full h-[1px] bg-surface-200"></div>
    <!--        Travellers-->
            @for (traveller of sortedTravellers(); track traveller;) {
              <div class="px-4 py-3">
                @if (!!traveller.details?.id && traveller?.details?.id === taSubmission()?.primaryTraveller?.details?.id
                     && traveller.details?.userType !== UserType.Casual) {
                  <p-button [rounded]="true" [text]="true" severity="secondary">
                    <i class="fa fa-star text-yellow-500"></i>
                  </p-button>
                } @else if (traveller.details?.userType !== UserType.Casual) {
                  <p-button [rounded]="true" [text]="true" severity="secondary" (onClick)="addPrimaryRole(traveller)">
                    <i class="fa-light fa-star text-surface-500"></i>
                  </p-button>
                }
              </div>
              <div class="px-4 py-3" [class.bg-yellow-50]="traveller.details?.userType === UserType.Casual">
                @if (isFlightOnly()) {
                  <!-- Single traveller: picking someone else replaces them. -->
                  <p-autocomplete [ngModel]="traveller"
                                  [dropdown]="true"
                                  [suggestions]="filteredTravellers"
                                  (completeMethod)="filterTravellers($event)"
                                  [forceSelection]="true"
                                  panelStyleClass="text-xs font-bold font-['Roboto_Condensed'] text-primary-900"
                                  placeholder="Type and/or select..."
                                  size="small"
                                  (onSelect)="replaceFlightOnlyTraveller($event.value)"
                                  [optionLabel]="getTravellersFullName">
                    <ng-template let-option #item>
                      <span class="text-xs font-bold font-['Roboto_Condensed'] text-primary-900 block" title="{{option.details?.email}}">
                        {{ getTravellersFullName(option) }} {{ getUserTypeSuffix(option.details) }}
                      </span>
                    </ng-template>
                  </p-autocomplete>
                } @else {
                  <p-autocomplete [ngModel]="traveller.details?.name + ' ' + getUserTypeSuffix(traveller.details)"
                                  [dropdown]="true"
                                  disabled
                                  [styleClass]="traveller.details?.userType === UserType.Casual ? 'bg-yellow-50' : ''"
                                  panelStyleClass="text-xs font-bold font-['Roboto_Condensed'] text-primary-900"
                                  placeholder="Type and/or select..."
                                  size="small"
                                  [forceSelection]="true"
                  ></p-autocomplete>
                }
              </div>
              @if (!isFlightOnly()) {
                <div class="px-4 py-3 flex items-center">
                  <p-checkbox
                    [ngModel]="traveller.isSelfAcquit"
                    (onChange)="updateTravellerAcquittal($event.checked, traveller)"
                    [disabled]="(!isDelegateTa() && !!taSubmission()?.travellers && taSubmission()!.travellers!.length === 1) || traveller.details?.userType === UserType.Casual"
                    [binary]="true"
                  />
                </div>
                <div class="px-4 py-3 flex items-center gap-2">
                  <p-checkbox
                    [ngModel]="!!traveller.authorisedAdjustmentDate"
                    (click)="deductionAuthCheck($event, traveller)"
                    [binary]="true"
                    [disabled]="(!!taSubmission()?.travellers && taSubmission()!.travellers!.length !== 1) || isDayTrip()"
                  />
                  @if (!!traveller.authorisedAdjustmentDate){
                    <div class="pl-3 pr-1 py-1 bg-primary-100 rounded-2xl inline-flex justify-start items-center gap-2">
                      <div class="justify-start text-chip-color text-xs font-normal font-['Roboto_Condensed']">{{authorityChipLabel(traveller)}} {{traveller.authorisedAdjustmentDate | date:'dd/MM/yy'}}</div>
                        <div class="rounded-full w-5 h-5 flex items-center justify-center text-white bg-primary text-lg font-medium">
                          <i class="fa-solid fa-check fa-2xs"></i>
                        </div>
                    </div>
                  }
                </div>
                <div class="px-4 py-3">
                  <p-button severity="danger" size="small" (onClick)="removeStaffTraveller(traveller)" [text]="true">
                    <div class="flex items-center gap-2">
                      <div class="rounded-full w-5 h-5 flex items-center justify-center text-white bg-red-500 text-lg font-medium">
                        <i class="fa-solid fa-minus fa-2xs"></i>
                      </div>
                      <span class="text-xs font-normal font-['Roboto_Condensed'] text-primary-900">Remove</span>
                    </div>
                  </p-button>
                </div>
              }
              <div class="col-span-full h-[1px] bg-surface-200"></div>
            }
    <!--        Empty Traveller: flight-only shows it only until a traveller is picked-->
            @if (!isFlightOnly() || !taSubmission()?.travellers?.length) {
              <div class="px-4 py-3">
              </div>
              <div class="px-4 py-3">
                <p-autocomplete [(ngModel)]="emptyTraveller"
                                [dropdown]="true"
                                [suggestions]="filteredTravellers"
                                (completeMethod)="filterTravellers($event)"
                                [forceSelection]="true"
                                panelStyleClass="text-xs font-bold font-['Roboto_Condensed'] text-primary-900"
                                placeholder="Type and/or select..."
                                size="small"
                                (onSelect)="isFlightOnly() ? replaceFlightOnlyTraveller(emptyTraveller) : addStaffTraveller()"
                                [optionLabel]="getTravellersFullName">
                  <ng-template let-traveller #item>
                    <span class="text-xs font-bold font-['Roboto_Condensed'] text-primary-900 block"
                          [class.bg-yellow-50]="traveller.details?.userType === UserType.Casual" title="{{traveller.details?.email}}">
                      {{ getTravellersFullName(traveller) }} {{ getUserTypeSuffix(traveller.details) }}
                    </span>
                  </ng-template>
                  <ng-template let-traveller #selectedItem>
                    <span class="text-xs font-bold font-['Roboto_Condensed'] text-primary-900 block"
                          [class.bg-yellow-50]="traveller.details?.userType === UserType.Casual" title="{{traveller.details?.email}}">
                        {{ getTravellersFullName(traveller) }} {{ getUserTypeSuffix(traveller.details) }}
                    </span>
                  </ng-template>
                </p-autocomplete>
              </div>
              @if (!isFlightOnly()) {
                <div class="px-4 py-3">
        <!--          <p-checkbox [(ngModel)]="emptyTraveller.isSelfAcquit" [binary]="true" disabled></p-checkbox>-->
        <!--                      [disabled]="!emptyTraveller.details?.id" />-->
                </div>
                <div class="px-4 py-3">
        <!--          <p-checkbox [value]="taSubmission()!.isPrePaid" [binary]="true" (onChange)="taSubmissionDatasource.updateTaField('prePaid', $event.checked)"  disabled></p-checkbox>-->
        <!--          [disabled]="!emptyTraveller.details?.id" />-->
                </div>
                <div class="px-4 py-3">
    <!--              <p-button severity="primary" size="small" (onClick)="addStaffTraveller()" [text]="true" [disabled]="!emptyTraveller?.details?.id">-->
    <!--                <div class="flex items-center gap-2">-->
    <!--                  <div class="rounded-full w-5 h-5 flex items-center justify-center text-white bg-primary-500 text-lg font-medium">-->
    <!--                    <i class="fa-solid fa-plus fa-2xs"></i>-->
    <!--                  </div>-->
    <!--                  <span class="text-xs font-normal font-['Roboto_Condensed'] text-primary-900">Add</span>-->
    <!--                </div>-->
    <!--              </p-button>-->
                </div>
              }
              <div class="col-span-full h-[1px] bg-surface-200"></div>
            }
          </div>
          @if (taSubmissionDatasource.hasOnlyCasualTravellers()) {
            <div class="w-full bg-surface-0 px-4 pt-4">
              <ta-toast
                data-testid="travellers-all-casual-warning"
                title="A TA needs at least one staff traveller"
                severity="warn"
                [closable]="false"
                size="max"
              >
                <div class="flex flex-col gap-1">
                  <span>Casual travellers can't be the only travellers except for booking officer TAs.</span>
                  <span>Add a staff traveller before submitting.</span>
                </div>
              </ta-toast>
            </div>
          }
          <div class="w-full flex-1 bg-surface-0"></div>
        </div>
      </div>
    </p-card>

    @if (!isFlightOnly()) {
      <p-card>
        <div class="flex gap-2">
          <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
            <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter']">Non-CLC Staff</div>
            <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Add the full name of any <i><b>other</b></i> people travelling with the CLC staff members.</div>
          </div>
          <div class="flex-1 flex flex-col bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
            <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Non-CLC Traveller</div>

            <div class="flex w-full flex-wrap gap-1 py-4">
              @for (nonStaffTraveller of !!(taSubmission()?.nonClcTravellers) ? taSubmission()!.nonClcTravellers : []; let ii = $index; track ii) {
                <div class="flex">
                  <input type="text"
                         pInputText
                         [value]="nonStaffTraveller"
                         (change)="updateNonStaffTraveller($event, ii)"
                         placeholder="Enter full name"
                         pSize="small"
                         (keydown)="preventComma($event)"
                  />
                  @if (!!taSubmission()!.nonClcTravellers && taSubmission()!.nonClcTravellers!.length > 1) {
                    <icon-btn variant="minus-grey"
                            ariaLabel="Remove traveller"
                            class="px-2"
                            (click)="removeNonStaffTraveller(ii)" />
                  }
                </div>
              }
              <icon-btn variant="add-primary"
                      ariaLabel="Add traveller"
                      class="px-2"
                      (click)="addNonStaffTraveller()" />
            </div>
          </div>
        </div>
      </p-card>
    }
  </div>
}
